import BaseLeadChartPage from '../BaseLeadChartPage/BaseLeadChartPage'

export default function LeadByLeadSourceChartPage (props) {
  return <BaseLeadChartPage pageName={props.pageName} groupByKey={"none"} labelByKey={"lead_source"} showTotalPercentedRatio={true}/>
}
